/**
 * Get the initials of a name.
 * @param input The name to get the initials of.
 * @param length The number of initials to return.
 * @returns The initials of the name.
 */
export function getInitials(input: string, length: 1 | 2 = 2): string {
  if (!input) {
    return "";
  }

  const namePart = input.split("@")[0];
  const initials =
    namePart
      ?.split(/[\s\-.]/)
      .map((word) => word.charAt(0).toUpperCase())
      .join("") ?? "";

  return initials.substring(0, length);
}
